<template>
  <a-drawer
    :title="title"
    :maskClosable="true"
    :width="700"
    placement="right"
    :closable="true"
    @close="handleCancel"
    :visible="visible"
    style="overflow: auto; padding-bottom: 53px"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <div style="font-size: 20px; font-weight: 500">基本信息</div>
        <a-form-model-item
          label="话术类型"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            @change="getSpeechcraftCategory"
            v-decorator="[
              'type',
              { rules: [{ required: true, message: '请选择话术类型！' }] },
            ]"
            placeholder="请选择类型"
          >
            <a-select-option
              v-for="item in newQueryParam"
              :key="item.id"
              :disabled="item.name == '个人话术'"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-form-model-item>
        <a-form-model-item
          label="话术分类"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            @select="categoryChange"
            placeholder="请选择话术分类"
            @dropdownVisibleChange="dropdownChange"
            v-decorator="[
              'category',
              {
                initialValue: categoryName,
                rules: [{ required: true, message: '请选择话术分类！' }],
              },
            ]"
          >
            <a-select-option v-for="item in spcenList" :key="item.id">
              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  width: 100%;
                "
                @mouseenter="categoryHover(item.id)"
              >
                <div>{{ item.name }}</div>
                <div v-show="categoryId == item.id">
                  <span
                    style="margin-right: 10px"
                    @click.stop="selectCategoryEdit(item)"
                    ><a-icon type="edit"
                  /></span>
                  <span @click.stop="selectCategoryDel(item)"
                    ><a-icon type="delete"
                  /></span>
                </div>
              </div>
            </a-select-option>
            <!-- <div style="display: flex;justify-content: space-between;width: 100%;" v-for="item in spcenList" :key="item.id" >
                <a-select-option :value="item.id">{{item.name}}</a-select-option>
                <div>
                  <span style="margin-right: 10px;" @click.stop="selectCategoryEdit(item)"><a-icon type="edit" /></span>
                  <span @click.stop="selectCategoryDel(item)"><a-icon type="delete" /></span>
                </div>
            </div> -->

            <!-- <a-select-option v-for="item in spcenList" :key="item.id" :value="item.name">{{item.name}}</a-select-option> -->
            <div slot="dropdownRender" slot-scope="menu">
              <v-nodes :vnodes="menu" />
              <a-divider style="margin: 1px 0" />
              <div
                @click="onshowCategory"
                style="padding: 4px 8px; cursor: pointer"
              >
                <a-icon type="plus" />增加
              </div>
              <!-- <a-divider style="margin: 1px 0;" />
              <div @click="oneditCategory" style="padding: 4px 8px; cursor: pointer;">
                <a-icon type="edit" />编辑
              </div>
              <a-divider style="margin: 1px 0;" />
              <div @click="ondeleteCategory" style="padding: 4px 8px; cursor: pointer;">
                <a-icon type="delete" />删除
              </div> -->
              <a-modal
                v-model="showCategory"
                title="新增话术分类"
                @ok="addItem"
              >
                <a-input
                  placeholder="输入新增的话术分类名"
                  :maxLength="12"
                  v-decorator="['centstring']"
                  v-model="fenleiname"
                />
              </a-modal>
              <a-modal
                v-model="showeditCategory"
                title="编辑话术分类"
                @ok="editItem"
              >
                <a-input v-model="editname" :maxLength="12" />
              </a-modal>
            </div>
          </a-select>
        </a-form-model-item>
        <a-form-model-item
          label="话术简述"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            :maxLength="20"
            type="text"
            v-decorator="[
              'description',
              { rules: [{ required: true, message: '请输入话术简述！' }] },
            ]"
            placeholder="请填写话术使用场景或简单描述"
          />
        </a-form-model-item>

        <a-form-model-item
          label="添加话术"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-radio-group v-decorator="['msgType']" @change="typeChange">
            <a-radio value="text">文本</a-radio>
            <a-radio value="image">图片</a-radio>
            <a-radio value="video">视频</a-radio>
            <a-radio value="file">文件</a-radio>
            <a-radio value="news">链接</a-radio>
            <a-radio value="miniprogram">小程序</a-radio>
          </a-radio-group>
        </a-form-model-item>

        <a-form-model-item
          v-show="this.form.getFieldValue('msgType') == 'text'"
          label="文本"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-textarea
            placeholder="请添加文字话术"
            v-decorator="[
              'content',
              {
                rules: [
                  {
                    required:
                      this.form.getFieldValue('msgType') == 'text'
                        ? true
                        : false,
                    message: '请输入文字话术！',
                  },
                ],
              },
            ]"
            :auto-size="{ minRows: 3, maxRows: 5 }"
          />
        </a-form-model-item>
        <a-form-model-item
          v-show="this.form.getFieldValue('msgType') == 'image'"
          label="图片"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <UploadImage
            :accept="'.jpg, .png'"
            @handleFileList="
              (e) => {
                getFileList(e, 'picUrlTwo');
              }
            "
            :imgUrl="fileList.fileUrl"
            v-decorator="[
              'picUrlTwo',
              {
                required:
                  this.form.getFieldValue('msgType') == 'image' ? true : false,
                message: '请上传图片！',
              },
            ]"
          />
        </a-form-model-item>
        <a-form-model-item
          v-show="this.form.getFieldValue('msgType') == 'video'"
          label="视频"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <j-upload
            :number="1"
            accept=".mp4, .m4a, .mp3, .ogg, .mov"
            class="avatar-uploader"
            @zipFile="
              (e) => {
                _getFileList(e, 'videoUrl');
              }
            "
            v-decorator="[
              'videoUrl',
              {
                rules: [
                  {
                    required:
                      this.form.getFieldValue('msgType') == 'video'
                        ? true
                        : false,
                    message: '请上传视频！',
                  },
                ],
              },
            ]"
            :uploadUrl="url.uploadFiles"
            file-type="file"
            fileKey="file"
            text="添加视频"
          >
          </j-upload>
        </a-form-model-item>
        <!-- @zipFile="getFileList" -->
        <a-form-model-item
          v-show="this.form.getFieldValue('msgType') == 'file'"
          label="文件"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <j-upload
            :number="1"
            :file-type="fileType"
            v-decorator="[
              'fileUrl',
              {
                rules: [
                  {
                    required:
                      this.form.getFieldValue('msgType') == 'file'
                        ? true
                        : false,
                    message: '请上传文件！',
                  },
                ],
              },
            ]"
            fileKey="file"
            accept=".zip, .doc, .docx, .pdf, .jpg, .png"
            :uploadUrl="url.uploadFiles"
            class="avatar-uploader"
            text="上传"
            @zipFile="
              (e) => {
                _getFileList(e, 'fileUrl');
              }
            "
          >
          </j-upload>
          <a-icon
            v-if="false"
            type="file-text"
            theme="twoTone"
            :style="{
              fontSize: '80px',
              height: '200px',
              lineHeight: '200px',
              width: '100%',
            }"
          />
        </a-form-model-item>
        <div v-show="this.form.getFieldValue('msgType') == 'news'">
          <a-form-model-item
            label="链接地址"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <a-input
              v-decorator="[
                'link',
                {
                  rules: [
                    {
                      required:
                        this.form.getFieldValue('msgType') == 'news'
                          ? true
                          : false,
                      message: '请输入链接地址！',
                    },
                  ],
                },
              ]"
              placeholder="请输入链接地址"
            />
          </a-form-model-item>
          <a-form-model-item
            label="图文标题"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <a-input
              v-decorator="[
                'title',
                {
                  rules: [
                    {
                      required:
                        this.form.getFieldValue('msgType') == 'news'
                          ? true
                          : false,
                      message: '请输入标题！',
                    },
                  ],
                },
              ]"
              placeholder="请输入图文标题"
            />
          </a-form-model-item>
          <a-form-model-item
            label="图文封面"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <UploadImage
              :accept="'.jpg, .png'"
              :imgUrl="fileList.fileUrl"
              @handleFileList="
                (e) => {
                  getFileList(e, 'newsUrl');
                }
              "
              v-decorator="['newsUrl']"
            />
          </a-form-model-item>
          <a-form-model-item
            label="图文描述"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <a-input v-decorator="['desc']" placeholder="请输入图文描述！" />
          </a-form-model-item>
        </div>

        <div v-show="this.form.getFieldValue('msgType') == 'miniprogram'">
          <a-form-model-item
            label="appid"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <a-input
              v-decorator="[
                'appid',
                {
                  rules: [
                    {
                      required:
                        this.form.getFieldValue('msgType') == 'miniprogram'
                          ? true
                          : false,
                      message: '请输入appid！',
                    },
                  ],
                },
              ]"
              placeholder="请输入appid"
            />
          </a-form-model-item>
          <a-form-model-item
            label="展示标题"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <a-input
              v-decorator="[
                'titleMini',
                {
                  rules: [
                    {
                      required:
                        this.form.getFieldValue('msgType') == 'miniprogram'
                          ? true
                          : false,
                      message: '请输入标题！',
                    },
                  ],
                },
              ]"
              placeholder="请输入标题"
            />
          </a-form-model-item>
          <a-form-model-item
            label="消息封面"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <UploadImage
              :accept="'.jpg, .png'"
              :imgUrl="fileList.fileUrl"
              @handleFileList="
                (e) => {
                  getFileList(e, 'miniprogramUrl');
                }
              "
              v-decorator="[
                'miniprogramUrl',
                {
                  required:
                    this.form.getFieldValue('msgType') == 'miniprogram'
                      ? true
                      : false,
                  message: '请上传消息封面！',
                },
              ]"
            />
          </a-form-model-item>
          <a-form-model-item
            label="页面路径"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <a-input
              v-decorator="[
                'page',
                {
                  rules: [
                    {
                      required:
                        this.form.getFieldValue('msgType') == 'miniprogram'
                          ? true
                          : false,
                      message: '请输入页面路径！',
                    },
                  ],
                },
              ]"
              placeholder="请输入页面路径（以.html作为后缀）"
            />
          </a-form-model-item>
        </div>

        <a-form-model-item
          v-show="false"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input v-decorator="['fileName']" />
        </a-form-model-item>
        <a-form-model-item
          v-show="false"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input v-decorator="['url']" />
        </a-form-model-item>
      </a-form>
    </a-spin>

    <div class="drawer-bootom-button">
      <a-popconfirm
        title="确定放弃编辑？"
        @confirm="handleCancel"
        okText="确定"
        cancelText="取消"
      >
        <a-button style="margin-right: 0.8rem">取消</a-button>
      </a-popconfirm>
      <a-button @click="handleSubmit" type="primary">提交</a-button>
    </div>
  </a-drawer>
</template>

<script>
import pick from 'lodash.pick';
import JSelectPosition from '@/components/jeecgbiz/JSelectPosition';
import { postTag, postAction } from '@/api/manage';
import { querySpeechcraftInfoById, querySpeechcraftCategory } from '@/api/api';
import JImageUpload from '../../../components/jeecg/JImageUpload';
import JUpload from '../../../components/jeecg/JUpload';
import { axios } from '@/utils/request';
import UploadImage from '@/components/common/UploadImage';

// import JUpload from '@/components/jeecg/JUploadModal'
// import JUpload from '../../../components/jeecg/JUploadModal'

export default {
  name: 'addSpeechcraftModal',
  components: {
    JImageUpload,
    JUpload,
    JSelectPosition,
    UploadImage,
    VNodes: {
      functional: true,
      render: (h, ctx) => ctx.props.vnodes,
    },
  },
  props: {
    typeList: Array, //将选择条件传递到弹窗。主要用到话术类型数组
  },
  computed: {
    newQueryParam() {
      return this.typeList;
    },
  },
  data() {
    return {
      fileType: 'file',
      title: '操作',
      visible: false,
      model: {},
      labelCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 5,
        },
      },
      wrapperCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 16,
        },
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      url: {
        uploadFiles:
          process.env.VUE_APP_CMS_WECHATUSERSBIZ + '/speechcraft/fileUpload',
        add:
          process.env.VUE_APP_CMS_WECHATUSERSBIZ +
          '/speechcraft/addSpeechcraft',
        edit:
          process.env.VUE_APP_CMS_WECHATUSERSBIZ +
          '/speechcraft/editSpeechcraft',
      },
      fileList: [],
      spcenList: [], //话术分类数组
      showCategory: false, //展示新建话术分类弹窗,
      showeditCategory: false, //展示修改话术分类弹窗
      editname: '',
      fenleiname: '',
      sendFileName: '',
      minioFileName: '',
      categoryId: '', //hover时话术类型的id
      categoryName: '',
    };
  },
  methods: {
    add() {
      this.edit({});
    },
    edit(record, type) {
      //编辑
      this.form.resetFields();
      this.visible = true;
      if (record.id) {
        //判断是否编辑
        querySpeechcraftInfoById({
          id: record.id,
        }).then((res) => {
          if (res.success) {
            if (res.result) {
              let obj = res.result;
              this.model = Object.assign({}, res.result);
              this.model.id = record.id;
              if (obj.msgType === 'image') {
                // this.model.picUrlTwo = this.previewUrl + obj.id
                this.model.picUrlTwo =
                  process.env.VUE_APP_CMS_MINIOURL + obj.imgUrl;
              } else if (obj.msgType === 'video') {
                this.model.videoUrl = [
                  {
                    name: '',
                    url: '',
                    uid: '',
                    status: '',
                    speechcraft: true,
                  },
                ];
                this.model.videoUrl[0].name = obj.fileName;
                this.model.videoUrl[0].url = obj.videoUrl;
                this.model.videoUrl[0].uid = '1';
                this.model.videoUrl[0].status = 'done';
              } else if (obj.msgType === 'file') {
                // this.model.videoUrl = obj.fileUrl
                this.model.fileUrl = [
                  {
                    name: '',
                    url: '',
                    uid: '',
                    status: '',
                    speechcraft: true,
                  },
                ];
                this.model.fileUrl[0].name = obj.fileName;
                this.model.fileUrl[0].url = obj.fileUrl;
                this.model.fileUrl[0].uid = '1';
                this.model.fileUrl[0].status = 'done';
              } else if (obj.msgType === 'news') {
                this.model.newsUrl =
                  process.env.VUE_APP_CMS_MINIOURL + obj.newsUrl;
              } else {
                this.model.miniprogramUrl =
                  process.env.VUE_APP_CMS_MINIOURL + obj.minUrl;
                this.model.titleMini = obj.title;
              }
              this.model.fileName = obj.fileName;
              this.model.url = process.env.VUE_APP_CMS_MINIOURL + obj.url;
              if (obj.type) {
                this.getSpeechcraftCategory(obj.type);
              }

              console.log(this.model);
              this.$nextTick(() => {
                this.form.setFieldsValue(
                  pick(
                    this.model,
                    'type',
                    'category',
                    'centstring',
                    'description',
                    'msgType',
                    'content',
                    'picUrlTwo',
                    'link',
                    'title',
                    'newsUrl',
                    'desc',
                    'appid',
                    'titleMini',
                    'miniprogramUrl',
                    'page',
                    'fileName',
                    'url'
                  )
                );
                this.form.setFieldsValue({ fileUrl: this.model.fileUrl });
                this.form.setFieldsValue({ videoUrl: this.model.videoUrl });
              });
            }
          }
        });
      } else {
        this.model = Object.assign({
          msgType: 'text',
        });

        this.$nextTick(() => {
          this.form.setFieldsValue(
            pick(
              this.model,
              'type',
              'category',
              'centstring',
              'description',
              'msgType',
              'content',
              'picUrlTwo',
              'videoUrl',
              'fileUrl',
              'link',
              'title',
              'newsUrl',
              'desc',
              'appid',
              'titleMini',
              'miniprogramUrl',
              'page',
              'fileName',
              'url'
            )
          );
        });
      }
    },
    //新增话术分类
    addCategory() {
      let type = this.form.getFieldValue('type');
      let centstring = this.form.getFieldValue('centstring') || this.fenleiname;
      console.log(type, centstring);
      let obj = {
        parentTagId: type,
        name: centstring,
      };
      postTag(
        process.env.VUE_APP_CMS_WECHATUSERSBIZ +
          '/speechcraft/addSpeechcraftCategory',
        obj
      ).then((res) => {
        console.log(res);
        if (res.success) {
          this.form.setFieldsValue({
            category: res.result,
          });
          if (res.result) {
            this.getSpeechcraftCategory(type);
          }
        }
      });
    },
    typeChange(e) {
      //添加话术tab切换
      // console.log(e.target.value);
      this.form.setFieldsValue({
        msgType: e.target.value,
      });
    },
    addItem() {
      //新增话术分类
      let type = this.form.getFieldValue('type');
      if (!type) {
        this.$message.error('请先选择话术类型');
        return;
      }
      this.showCategory = false;
      this.addCategory(); //新增话术分类
      this.form.setFieldsValue({
        centstring: '',
      });
    },
    // 弹出新增话术分类弹框
    onshowCategory() {
      this.fenleiname = '';
      let type = this.form.getFieldValue('type');
      if (type && type !== '') {
        this.showCategory = true;
      } else {
        this.$message.warning('请选择话术类型！');
      }
    },
    oneditCategory() {
      let type = this.form.getFieldValue('type');
      if (type && type !== '') {
        this.showeditCategory = true;
      } else {
        this.$message.warning('请选择话术类型！');
      }
    },
    _getFileList(e, key) {
      console.log(e, key);
      this.mediaId = '';
      let arr = e ? e[e.length - 1] : [];
      if (arr.response.success) {
        this.sendFileName = arr.response.result.fileName;
        this.minioFileName = arr.response.result.minioFileName;
        this.mediaId = arr.response.result.mediaId;
        let obj = {};
        let msgType = this.form.getFieldValue('msgType');
        if (
          msgType == 'image' ||
          msgType == 'news' ||
          msgType == 'miniprogram'
        ) {
          obj[key] = process.env.VUE_APP_CMS_MINIOURL + arr.url;
          console.log(process.env.VUE_APP_CMS_MINIOURL, obj[key]);
        } else {
          obj[key] = process.env.VUE_APP_CMS_MINIOURL + arr.response.result.url;
        }
        this.showCategory = false;
        // arr[0].speechcraft=true;
        if (msgType == 'video') {
          this.form.setFieldsValue({
            videoUrl: arr,
          });
        } else if (msgType == 'file') {
          this.form.setFieldsValue({
            fileUrl: arr,
          });
        }
        console.log(arr, 'arr');
      }
    },
    editItem() {
      //编辑话术分类
      let type = this.form.getFieldValue('type');
      if (!type) {
        this.$message.error('请先选择话术类型');
        return;
      }
      let id = this.form.getFieldValue('category');
      this.showeditCategory = false;
      let obj = {
        name: this.editname,
        id,
      };
      axios({
        url:
          process.env.VUE_APP_CMS_WECHATUSERSBIZ +
          '/speechcraft/editSpeechcraftCategory',
        method: 'post',
        data: obj,
      }).then((res) => {
        if (res.success) {
          this.getSpeechcraftCategory(type);
        }
      });
    },
    ondeleteCategory() {
      let id = this.form.getFieldValue('category');
      let type = this.form.getFieldValue('type');
      postAction(
        process.env.VUE_APP_CMS_WECHATUSERSBIZ +
          '/speechcraft/deleteSpeechcraftCategory',
        {
          id,
        }
      ).then((res) => {
        if (res.success) {
          this.form.resetFields('category');
          this.getSpeechcraftCategory(type);
          this.$message.success(`删除成功`);
          console.log(this.$ref.sayList);
        }
      });
    },

    selectCategoryDel(item) {
      console.log(item);
      let id = item.id;
      let type = this.form.getFieldValue('type');
      postAction(
        process.env.VUE_APP_CMS_WECHATUSERSBIZ +
          '/speechcraft/deleteSpeechcraftCategory',
        {
          id,
        }
      ).then((res) => {
        if (res.success) {
          this.form.resetFields('category');
          this.getSpeechcraftCategory(type);
          this.$message.success(`删除成功`);
          this.$forceUpdate();
        }
      });
    },

    selectCategoryEdit(item) {
      //编辑话术分类
      console.log(item);
      let type = this.form.getFieldValue('type');

      if (type && type !== '') {
        this.editname = item.name;
        this.$nextTick(() => {
          this.showeditCategory = true;
        });
      } else {
        this.$message.warning('请选择话术类型！');
      }
    },

    categoryHover(id) {
      if (this.showOption) {
        this.categoryId = id;
      }
    },

    dropdownChange() {
      this.showOption = true;
    },
    close() {
      this.$emit('close');
      this.visible = false;
      this.spcenList = [];
    },
    handleSubmit() {
      const that = this;

      this.form.validateFields((err, values) => {
        if (!err) {
          let urls = '';
          if (!this.model.id) {
            //根据id判断是否是新增
            urls = this.url.add;
          } else {
            urls = this.url.edit;
          }
          values.id = this.model.id;

          if (values.msgType == 'miniprogram') {
            values.title = values.titleMini;
          }
          values.fileName = this.sendFileName;
          values.minioFileName = this.minioFileName;
          values.mediaId = this.mediaId;
          values.imgUrl = values.picUrlTwo;
          values.minUrl = values.miniprogramUrl;
          // let getFileUrl=values.fileUrl.url.split('/')
          // values.fileUrl=getFileUrl[getFileUrl.length-2]+'/'+getFileUrl[getFileUrl.length-1]
          if (values.fileUrl) {
            values.fileUrl = values.fileUrl.url;
          }
          if (values.videoUrl) {
            values.videoUrl = values.videoUrl.url;
          }
          console.log(values.fileUrl);
          postTag(urls, values).then((res) => {
            if (res.success) {
              this.$message.success(res.message);
              this.$emit('ok');
              this.close();
            } else {
              this.$message.error(res.message);
            }
          });
        }
      });
    },
    handleCancel() {
      this.close();
    },
    getSpeechcraftCategory(id) {
      // 获取话术分类
      querySpeechcraftCategory({
        typeId: id,
      }).then((res) => {
        if (res.success) {
          this.spcenList = res.result;
        }
      });
    },

    categoryChange(id, option) {
      this.form.setFieldsValue({
        category: id,
      });
      // console.log(option.componentOptions.children[0].text);
      this.editname = option.componentOptions.children[0].text;
      this.categoryId = '';
      this.showOption = false;
    },
    getFileList(url, key) {
      this.form.setFieldsValue({
        [key]: process.env.VUE_APP_FILE_PATH + url.fileName,
      });
      this.fileList = url;
      console.log(url, key);
    },
  },
};
</script>

<style scoped>
.avatar-uploader > .ant-upload {
  width: 104px;
  height: 104px;
}

.ant-upload-select-picture-card i {
  font-size: 49px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

.ant-table-tbody .ant-table-row td {
  padding-top: 10px;
  padding-bottom: 10px;
}

.drawer-bootom-button {
  position: absolute;
  bottom: -8px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}

.ant-form-item {
  margin-bottom: 20px;
}
</style>
